module.exports = __webpack_public_path__ + "img/exit.a295c2f0.svg";